module.exports = __webpack_public_path__ + "img/Tyme_Bank_Logo.b3e9f875.svg";